module.exports = __webpack_public_path__ + "img/compressed-2018232887912042496.38fcd554.png";